  <!-- 查看地址弹窗表格 -->
<template>
  <div id="viewAddr">
    <div class="glo_Table">
      <el-table :height="tableHeight" header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe :highlight-current-row="true">
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60" />

        <el-table-column fixed="left" align="center" type="selection" width="60" />
        <el-table-column v-for="(item, index) in tableHead" :key="index" :label="item.name" :prop="item.field" align="center" :show-overflow-tooltip="true" :min-width="item.width" />
      </el-table>
    </div>
  </div>
</template>
<script >
export default {
  components: {},
  props: {
    addrTableData: {
      type: Array,
    },
    addrTableHead: {
      type: Array,
    },
  },
  watch: {
    addrTableData: {
      handler(newValue, oldValue) {
        this.tableData = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },
  data() {
    return {
      tableHeight: "75vh", //  表格高度
      tableData: this.addrTableData,
      tableHead: this.addrTableHead,
    };
  },
  methods: {
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang="less">
#viewAddr {
  padding-top: 20px;
}
</style>
